// extracted by mini-css-extract-plugin
export default {"inputBase":"DateInput_inputBase__1oFyH"};